import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  CircularProgress,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button
} from '@mui/material';
import { Edit as EditIcon, Delete as DeleteIcon } from '@mui/icons-material';
import { NotificationManager } from 'react-notifications';
import getPaymentModeService from '../../../services/getPaymentModeService';
import Pagination from '@mui/material/Pagination';

const List = ({
  open,
  setOpen,
  dialogType,
  setDialogType,
  editValue,
  setEditValue,
  fetchedData,
  filterVal,
  setFilterVal,
  fetchData,
  totalPages,
  currentPage,
  onPageChange,
  loading
}) => {
  const [deleteDialogOpen, setDeleteDialogOpen] = React.useState(false);
  const [bankToDeleteId, setBankToDeleteId] = React.useState(null);

  const handleEdit = (bank) => {
    setEditValue(bank);
    setDialogType('edit');
    setOpen(true);
  };

  const handleDelete = async (bankId) => {
    setBankToDeleteId(bankId);
    setDeleteDialogOpen(true);
  };

  const handleConfirmDelete = async () => {
    try {
      const response = await getPaymentModeService.DeleteBank(bankToDeleteId);
      if (response.success) {
        fetchData();
      }
    } catch (error) {
      console.error('Error deleting bank:', error);
    } finally {
      setDeleteDialogOpen(false);
      setBankToDeleteId(null);
    }
  };

  const handleCancelDelete = () => {
    setDeleteDialogOpen(false);
    setBankToDeleteId(null);
  };

  const handleChangePage = (event, newPage) => {
    onPageChange(newPage);
  };


  // const currentData = fetchedData;

    // Calculate the start and end indices for the current page
    const startIndex = (currentPage - 1) * filterVal.limit;
    const endIndex = startIndex + filterVal.limit;
    const currentData = fetchedData.slice(startIndex, endIndex);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <div>


      <TableContainer
        component={Paper}
        sx={{
          height: "330px",
          overflow: "auto",
          "& .MuiTable-root": {
            height: "100%",
          },
          "& .MuiTableBody-root": {
            overflowY: "auto",
            flexGrow: 1,
          },
          "& .MuiTableHead-root": {
            position: "sticky",
            top: 0,
            backgroundColor: "white",
            zIndex: 1,
          },
        }}
      >
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>Bank Name</TableCell>
              <TableCell className="text-end">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={2} sx={{ border: 0 }}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "250px",
                    }}
                  >
                    <CircularProgress />
                  </Box>
                </TableCell>
              </TableRow>
            ) : (
                currentData.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={2} sx={{ textAlign: "center", border: 0 }}>
                  <b> No search result found</b>

                  </TableCell>
                </TableRow>
              ) : (
                currentData.map((row) => (
                  <TableRow key={row.bankId}>
                    <TableCell>{row.bankName}</TableCell>
                    <TableCell className="text-end">
                      <IconButton
                        color="primary"
                        onClick={() => handleEdit(row)}
                      >
                        <EditIcon />
                      </IconButton>
                      <IconButton
                        color="error"
                        onClick={() => handleDelete(row.bankId)}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              )
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <Box sx={{ display: "flex", justifyContent: "center", my: 3 }}>
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={handleChangePage}
          color="primary"
          showFirstButton
          showLastButton
          sx={{
            "& .MuiPaginationItem-root": {
              fontSize: "1rem",
            },
            "& .Mui-selected": {
              backgroundColor: "#1976d2 !important",
              color: "white",
            },
          }}
        />
      </Box>

      <Dialog
        open={deleteDialogOpen}
        onClose={handleCancelDelete}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
      >
        <DialogTitle id="delete-dialog-title">{"Confirm Deletion"}</DialogTitle>
        <DialogContent>
          <p id="delete-dialog-description">
            Are you sure you want to delete this bank?
          </p>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelDelete}>Cancel</Button>
          <Button onClick={handleConfirmDelete} color="error" autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default List; 